import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/icon_back.png'
import _imports_1 from '@/assets/common/logo_688v.png'
import _imports_2 from '@/assets/common/head_icon.jpg'
import _imports_3 from '@/assets/common/copy_icon.png'


const _hoisted_1 = { class: "user_account" }
const _hoisted_2 = { class: "user_ID" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "menu_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "menu_item_text" }
const _hoisted_8 = { class: "share_content" }
const _hoisted_9 = ["src"]

import { computed, inject, ref } from 'vue'
import PrimaryButton from '../common/primaryButton.vue'
import { useRouter } from 'vue-router'
import CollectPopup from '@/view/collect/collectPopup.vue'
import CollectTimeDropPopup from '@/view/collect/collectTimeDropPopup.vue'
import AgentPopup from '@/view/agent/agentPopup.vue'
import { playClickSound } from '@/utils/media'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity'
import { useUserStore } from '@/stores/user'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import { goToShare, handleMenuClick, SHARE_LIST, SideMenuListItem, useButtonClick } from '@/view/components/supportFunction'
import { copyID } from '@/view/profile/supportScript'

export default /*@__PURE__*/_defineComponent({
  __name: 'sideNavbar',
  props: {
    listGameData: {}
  },
  emits: ['goToGamePanelSlide'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const activityStore = useActivityStore()
const userStore = useUserStore()
const userAccount = computed(() => userStore.loginAccount)
const uId = computed(() => userStore.id)
const { t } = useI18n();
const { buttonClick } = useButtonClick()
const router = useRouter()
const show = ref(false)
const menuList = computed<SideMenuListItem[]>(() => activityStore.activityList)

const shareList = ref(SHARE_LIST)

const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const statusRef = ref()
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const agentRef = ref()
const emits = __emit
const token = ref(localStorage.getItem('token'))
const isLogin = ref(token.value ? true : false)
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const sidebarRef = ref<any>(null);

const resetScroll = () => {
   if (sidebarRef.value?.$el) {
      sidebarRef.value.$el.scrollTop = 0;
   }

   const popupEl = document.querySelector('.van-popup--left');
   if (popupEl) {
      popupEl.scrollTop = 0;
   }
};
const openSidebar = () => {
   show.value = true
}

const closeSidebar = () => {
   playClickSound()
   show.value = false
}
const openRegisterPopup = (type: number) => {
   openRegisterLoginPopup?.(type)
}
const props = __props

const onCopyID = (id: any) => copyID(statusRef, id)

const menuClick = (name: any) => {
   handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )

}
const goToGamePannel = (data: any) => {
   emits('goToGamePanelSlide', data)
}

__expose({
   openSidebar,
   closeSidebar
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((show).value = $event)),
      onClickOverlay: _cache[7] || (_cache[7] = () => _unref(playClickSound)()),
      position: "left",
      onOpened: resetScroll,
      ref_key: "sidebarRef",
      ref: sidebarRef,
      style: { height: '100%', width: '74%', zIndex: '10002', paddingBottom: '48px' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_row, {
          class: "navBar",
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "4",
              onClick: closeSidebar,
              class: "navBar_menu"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "20",
              class: "navBar_logo"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                }, null, -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(userStore).loginAccount)
          ? (_openBlock(), _createBlock(_component_van_row, {
              key: 0,
              class: "user_info"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "6",
                  onClick: closeSidebar,
                  class: "user_avatar"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: ""
                    }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "18",
                  class: "user_text"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(userAccount.value), 1),
                    _createElementVNode("div", _hoisted_2, [
                      _createTextVNode(_toDisplayString(_ctx.$t('profile.id')) + "：" + _toDisplayString(uId.value) + " ", 1),
                      _createElementVNode("img", {
                        src: _imports_3,
                        alt: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (onCopyID(uId.value)))
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(userStore).loginAccount)
          ? (_openBlock(), _createBlock(_component_van_row, {
              key: 1,
              class: "user_info"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "btn_col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "loginButton",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (openRegisterPopup(1)))
                    }, _toDisplayString(_ctx.$t('common.login')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "btn_col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "registerButton",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (openRegisterPopup(0)))
                    }, _toDisplayString(_ctx.$t('common.register')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_van_row, { class: "button_group" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "12",
              class: "btn_grid"
            }, {
              default: _withCtx(() => [
                _createVNode(PrimaryButton, {
                  icon: require('@/assets/sideNavbar/home_recharge.png'),
                  text: _ctx.$t('common.deposite'),
                  textColor: "#FFFFFF",
                  bgColor: "#3d2e22",
                  onOnClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(buttonClick)('topup')))
                }, null, 8, ["icon", "text"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "btn_grid"
            }, {
              default: _withCtx(() => [
                _createVNode(PrimaryButton, {
                  icon: require('@/assets/sideNavbar/home_withdrawal.png'),
                  text: _ctx.$t('common.sake'),
                  textColor: "#FFFFFF",
                  bgColor: "#3d2e22",
                  onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(buttonClick)('withdraw')))
                }, null, 8, ["icon", "text"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.listGameData, (item) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              class: "game_list",
              key: item.id,
              onClick: ($event: any) => (goToGamePannel(item)),
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "24",
                  class: "game_img_col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "game_icon",
                      src: item.customIcon,
                      alt: ""
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_row, { class: "menu_row" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_col, {
                  span: "11",
                  key: index,
                  class: "menu_grid_item"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "menu_item_inner",
                      onClick: ($event: any) => (menuClick(item.name))
                    }, [
                      _createElementVNode("img", {
                        class: "menu_item_icon",
                        src: item.activity_icon,
                        alt: ""
                      }, null, 8, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)(`activityName.${item.name}`)), 1)
                    ], 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "share_item",
              key: index
            }, [
              _createElementVNode("img", {
                src: item.img,
                alt: "",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(goToShare) && _unref(goToShare)(...args)))
              }, null, 8, _hoisted_9)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(CollectPopup, {
      ref_key: "collectPopupRef",
      ref: collectPopupRef
    }, null, 512),
    _createVNode(CollectTimeDropPopup, {
      ref_key: "collectTimeDropPopupRef",
      ref: collectTimeDropPopupRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      content: _ctx.$t('common.copied'),
      isShowSuccess: true
    }, null, 8, ["content"]),
    _createVNode(AgentPopup, {
      ref_key: "agentRef",
      ref: agentRef
    }, null, 512),
    _createVNode(PwaAntiBlockingPopup, {
      ref_key: "pwaPopupRef",
      ref: pwaPopupRef
    }, null, 512),
    _createVNode(PwaStatusPopup, {
      ref_key: "pwaPopupStatusRef",
      ref: pwaPopupStatusRef
    }, null, 512)
  ], 64))
}
}

})